module.exports = __webpack_public_path__ + "img/radio-box-off.c1051556.svg";